<button [ngStyle]="stylesObj" mat-raised-button color="primary" [class]="buttonClasses" (click)="buttonClicked($event)">
  <ng-container *ngIf="isLoading">
    <div class="spinner-border" style="color: #ffffff" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </ng-container>
  <ng-container *ngIf="!isLoading">{{ buttonText }}</ng-container>
</button>
